import { render, staticRenderFns } from "./waiting-sample-recollect.vue?vue&type=template&id=079fa5a9&"
import script from "./waiting-sample-recollect.vue?vue&type=script&lang=js&"
export * from "./waiting-sample-recollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports